import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { AddEditVendors, AddEditLocationModal, AddLocationModal } from 'modals';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { deleteLocationData, getLocationListData } from '_services/accountsServices/locationService';
import { deleteCityLocationById, getCityLocationList } from '_services/accountsServices/cityLocationService';

const Location = () => {
  useDocumentTitle("Location | T360");

  const prevFilterRef = useRef();
  const { settingChild } = useContext(UserContext);
  const settingChildLocation = settingChild?.find((i) => i?.label === "Location");
  const [isOpenLocationModal, setIsOpenLocationModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [LocationList, setLocationList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [showGoogleMapModal, setShowGoogleMapModal] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    countryCode: "IN",
    stateCode: "",
  });

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "S No.", accessor: "serialNo" },
    { header: "City", accessor: "name" },
    { header: "State", accessor: "stateName" },
    { header: "Latitude", accessor: "latitude" },
    { header: "Longitude", accessor: "longitude" },
    { header: "Status", accessor: "status" },
    // { header: "Action", accessor: "action" },
  ];

  const toggleLocationModal = () => {
    setIsOpenLocationModal(!isOpenLocationModal);
  };

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      const filteredValues = Object.entries(filter)
        .filter(
          ([key, val]) =>
            key !== "offset" &&
            key !== "limit" &&
            key !== "company_id" &&
            key !== "countryCode" &&
            val !== "" &&
            val !== null &&
            val !== undefined &&
            val !== 0
        )
        .map(([_, val]) => val);

      setFilterCount(filteredValues.length);
      getDataLocationList();
      prevFilterRef.current = filter;
    }


  }, [filter]);


  const getDataLocationList = async () => {
    try {
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getCityLocationList(object);
      if (res?.responseCode == 200) {
        setLocationList(res?.data?.all_cities || []);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }


  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteConsignor = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        Location_id: isDelete?._id,
      }
      const res = await deleteCityLocationById(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataLocationList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.error('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  const callBackDataMap = (data) => {
    getDataLocationList();
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteConsignor,
    isLoadding: loading,
  }

  let gmapLocate = {
    isOpen: isOpenLocationModal,
    closeModal: (e) => setIsOpenLocationModal(false),
    modalMainClass: "_dashCommon_Modal _mdModalLoction",
    modalTitle: isOpenLocationModal?.view ? "View Location" : isOpenLocationModal?.edit ? "Edit Location" : 'Add Location',
    submitTitle: isOpenLocationModal?.view ? "View Location" : isOpenLocationModal?.edit ? "Update Location" : 'Add Location',
    callBackDataMap: callBackDataMap
  };



  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      serialNo: <>{Number(i + 1 + filter?.limit * (filter?.offset - 1))}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {settingChildLocation?.view === 1 && <Link
              className='_avPointer'
              // onClick={(e) => setIsOpenLocationModal({...item,view:true})}
              style={{ textDecoration: 'none' }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye />
                </span>View
              </span>
            </Link>}

            {settingChildLocation?.edit === 1 && <div
              // onClick={(e) => setIsOpenLocationModal({...item,edit:true})}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit />
                </span>
                Edit
              </span>
            </div>}

            {settingChildLocation?.delete === 1 && <div
              // onClick={(e) => deleteHandler(item)}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
                Delete
              </span>
            </div>}
          </div>
        </div>
      </>,
      Location: <>{item?.name ? item?.name : '-'}</>,
      number_of_unit: <>{item?.contact_nunber ? item?.contact_nunber : '-'}</>,
      number_of_consignee: <>{item?.consignor_group_id?.name ? item?.consignor_group_id?.name : '-'}</>,
      status: <>  {item?.active ? constant.activeArray[item?.active] : '-'} </>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {settingChildLocation?.view === 1 && <Link
            className='_avPointer'
            // onClick={(e) => setIsOpenLocationModal({...item,view:true})}
            style={{ textDecoration: 'none' }}
          >
            <span className='_samAnchor'>
              <span className='viewIcon_avt'>
                <AiOutlineEye color='green' />
              </span>
            </span>
          </Link>}

          {settingChildLocation?.edit === 1 && <div
            // onClick={(e) => setIsOpenLocationModal({...item,edit:true})}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>

            </span>
          </div>}

          {settingChildLocation?.delete === 1 && <div
            // onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>

            </span>
          </div>}
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };


  const clearFilter = () => {

    setFilter((pre) => ({
      ...pre,
      stateCode: "",
      search: ""
    }))
  }

  return (
    <div className="__profilCmp_main setting-nw-parentBx">
      <ButtonHeading
        title={"Location"}
        onClick={toggleLocationModal}
        // buttonTitle={settingChildLocation?.create === 1 && "Add Location"}
        buttonTitle={"Add Location"}
        className="commonHeading_title"
        showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
        filterCount={filterCount}
        clearFilter={clearFilter}
        section="settings"
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          tableClass="nrml-tbl"
          columns={columns}
          data={rowListData(LocationList?.length > 0 ? LocationList : [])}
          isLoading={loading}
        />

        {LocationList?.length > 0 && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}
      </div>



      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
            isShow={{
              state: true,

            }}
            name="Location"
            setFilterCount={setFilterCount}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>
      {isOpenLocationModal && <AddLocationModal {...gmapLocate} />}
    </div>
  )
}

export default Location